import axios from "axios";
import { GET_ALL_NOTIFICATION, GET_UNREAD_NOTIFICATION } from "../actions";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const PROXY = process.env.REACT_APP_URL + "api/";

// Load User
export const getNotification = (page, limit, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${PROXY}notification/all?page=${page}&limit=${limit}&search=${search}`
    );
    dispatch({
      type: GET_ALL_NOTIFICATION,
      payload: res?.data?.result,
    });
    return res?.data?.result;
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};

export const getUnreadData = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}notification/admin/count`);
    dispatch({
      type: GET_UNREAD_NOTIFICATION,
      payload: res.data?.result?.unread,
    });
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};

export const notificationAlert = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}notification/read/unread`, data);
  return res;
};
